module.exports = __webpack_public_path__ + "img/bonus1.9fa5f09c.png";